<template>
  <div class="mustPlay_list">
    <loading v-if="isLoading"></loading>
    <div v-else>
      <div v-if="!isPageError">
        <!-- <van-search shape="round" :left-icon="require('../../assets/iconImage/ic_20_search@2x.png')" placeholder="搜索必玩内容" @click="toSearchPage" /> -->
        <van-sticky>
          <div class="head_tags">
            <div class="tag_classif">
              <div class="tag_checkout">
                <tab-checkout ref="mySwiper" :array="classifyArray" :slideToClickedSlide="false" :activeIndex="classifyActive" @itemClick="classifyCheckout"></tab-checkout>
              </div>
            </div>
          </div>
        </van-sticky>

        <div class="list_container">
          <div class="list">
            <van-list v-if="!isEmptyData" v-model="loading" :finished="finished" finished-text="没有更多了..." @load="onLoad">
              <div slot="loading">
                <img class="loading_class" :style="{width:'45px',height:'45px'}" :src="require('../../assets/images/loading.gif')" />
              </div>
              <left-img :tagIsArray="true" :src="item.imageList?item.imageList[0]:''" :imageWidth="75" :imageHeight="100" v-for="(item,index) in listData" :item="item" @itemClick="toDetail(item)" :key="index">
                <div slot="right_container" class="right_container">
                  <div class="right_title">{{item.name}}</div>
                  <div class="right_label">
                    <!-- <div class="label_item type">{{item.headerTagName}}</div> -->
                    <div class="label_item" v-for="(item,index) in item.tags" :key="index" v-show="index < 2">{{item}}</div>
                  </div>
                  <div slot="right_time">
                    <div class="right_time">#{{item.headerTagName}}</div>
                  </div>
                  <div v-if="isShowDistance">
                    <div v-if="item.contentType == 8" class="right_like">{{item.gameTime}}</div>
                    <div v-else-if="item.contentType == 7 || item.contentType == 2 || item.contentType == 4" class="right_like">{{item.sourceName?item.sourceName:'常驻活动'}}</div>
                    <div v-else-if="item.contentType == 3" class="right_like">{{item.sourceName}}<span v-if="distance(item.latitude,item.longitude).distance">&nbsp;&nbsp;|&nbsp;&nbsp;距你{{distance(item.latitude,item.longitude).distance}}{{distance(item.latitude,item.longitude).text}}</span></div>
                    <div v-else class="right_like">全程{{item.routeDistance}}公里<span v-if="distance(item.latitude,item.longitude).distance">&nbsp;&nbsp;|&nbsp;&nbsp;距你{{distance(item.latitude,item.longitude).distance}}{{distance(item.latitude,item.longitude).text}}</span></div>
                  </div>
                </div>
              </left-img>
            </van-list>
            <van-empty v-else class="custom-image" :image="require('../../assets/img/data_empty.png')" description="暂无数据" />
          </div>
        </div>
      </div>
      <page-error v-else></page-error>
    </div>
    <img v-show="false" id="share_img" src="../../assets/img/line_share.png" alt="">
  </div>
</template>

<script>
import TabCheckout from '@/components/TabCheckout';
import LeftImg from '@/components/LeftImgRightText';
import PageError from '../../components/PageError';
import { getDistance } from '../../common/common';
import Loading from '@/components/loading';
export default {
  name: "mustPlay_list",
  data() {
    return {
      // 类别 当前选中下标
      classifyActive: 0,
      // 类别 tags 数组
      classifyArray: [{
        id: '',
        tagName: '推荐'
      }],
      // 2、景区 3、景点 7、活动 8、赛事 5、线路 4、攻略
      contentType: '',
      pageIndex: 1,
      pageSize: 10,
      listData: [],
      // 是否在加载中
      loading: true,
      // 是否已加载完成
      finished: false,
      // 数据是否为空
      isEmptyData: false,
      isPageError: false,
      isLoading: true,
      isShowDistance: false
    };
  },
  components: {
    TabCheckout,
    LeftImg,
    PageError,
    Loading
  },
  mounted() {
    console.log(this.$route.query.scenicId, 'this.$route.query.scenicId');
    this.isShowDistance = Boolean(sessionStorage.getItem('isShowDistance'));
    if (this.$route.query.listType) {
      // tag选中
      this.contentType = this.$route.query.listType;
      this.classifyArray = [];
    }
    if (this.$route.query.isPark) {
      document.title = '必玩内容';
    } else {
      document.title = '热点推荐';
    }
    this.getListData(() => {
      this.initCheckoutTab();
    });
    setTimeout(() => {
      this.shareInit();
    }, 500)
    console.log(window.location.origin, 'origin')
  },
  methods: {

    initCheckoutTab() {
      this.$nextTick(() => {
        console.log(this.classifyArray, 'classifyArray');
        for (let i in this.classifyArray) {
          if (this.$route.query.listType == this.classifyArray[i].id) {
            this.classifyActive = Number(i);
            this.listType = this.classifyArray[i].id;
            this.contentType = this.classifyArray[i].id;

            // this.$refs['mySwiper'].gotoSlider(i);
          }
        }
        for (let i in this.classifyArray) {
          this.listData[i].headerTagName = this.classifyArray[this.classifyActive].tagName;
        }
        // 全部数据 无需处理
        // if (this.$route.query.listType == 1) { // 活动
        //   this.classifyActive = 1;
        //   this.$refs['mySwiper'].gotoSlider(1);

        // } else if (this.$route.query.listType == 3) {  // 景点
        //   this.classifyActive = 3;
        //   this.$refs['mySwiper'].gotoSlider(2);
        // }
      })

    },

    /**
     * 类别 tag切换触发
     */
    classifyCheckout(data) {
      if (!this.loading) {
        this.classifyActive = data.index;
        this.contentType = data.id;
        this.isEmptyData = false;
        this.listData = [];
        this.pageIndex = 1;
        this.getListData();
      }

    },
    /**
     * 跳转详情 
     */
    toDetail(item) {
      console.log(item, 'item')
      if (this.$route.query.isPark) {  //由景区列表来
        if (this.contentType == 1) {  // 活动
          this.$router.push({
            path: '/activityDetails',
            query: {
              id: item.id,
            },
          });
        } else if (this.contentType == 3) { //景点
          this.$router.push({
            path: '/scenicSpot',
            query: {
              id: item.scenicId,
              lat: this.$route.query.lat,
              lng: this.$route.query.lng,
            },
          });
        }
      } else {
        if (item.contentType == 3) {  //景点
          this.$router.push({
            path: '/scenicSpot',
            query: {
              id: item.contentId,
              lat: this.$route.query.lat,
              lng: this.$route.query.lng,
            },
          });
        } else if (item.contentType == 4) {  // 攻略
          this.$router.push({
            path: '/strategyDetails',
            query: {
              id: item.contentId,
              lat: this.$route.query.lat,
              lng: this.$route.query.lng,
            },
          });
        } else if (item.contentType == 7) {  // 活动
          this.$router.push({
            path: '/activityDetails',
            query: {
              id: item.contentId,
            },
          });
        } else if (item.contentType == 8) {  // 赛事
          window.location.href = `https://cos-web-h5.wiiqq.com/fwpt-h5-dc/index.html#/detail/${item.contentId}`;
        } else if (item.contentType == 2) {  // 景区名片
          this.$router.push({
            path: '/scenicParkDetail',
            query: {
              id: item.contentId,
              lat: this.$route.query.lat,
              lng: this.$route.query.lng,
            },
          });
        } else if (item.contentType == 5) {  // 线路
          this.$router.push({
            path: '/lineDetails',
            query: {
              id: item.contentId,
              lat: this.$route.query.lat,
              lng: this.$route.query.lng,
            },
          });
        } else {
          this.$toast('无法识别的类型');
        }
      }

    },

    /**
    * 点击 跳转搜索页
    */
    toSearchPage() {
      this.$router.push({
        path: '/bigSearch',
      });
    },


    getListData(callback) {
      if (this.$route.query.isPark) {

        this.getListDataForPark(callback);
      } else {

        this.getListDataDefault();
      }
    },

    /**
     * 请求列表数据
     */
    getListDataDefault() {
      this.loading = true;
      this.finished = false;
      this.$request.get(`/appserver/v1/mustPlay/list?scenicId=${this.$route.query.scenicId}&contentType=${this.contentType}&pageIndex=${this.pageIndex}&pageSize=${this.pageSize}`).then((res) => {
        if (res.data.ret == 0) {
          let resData = res.data.data;
          // 顶部tag标签动态获取
          if (this.classifyArray.length <= 1) {
            for (let i in resData.headerTagList) {
              this.classifyArray.push({
                id: resData.headerTagList[i].contentType,
                tagName: resData.headerTagList[i].headerTagName,
              })
            }
          }
          // 列表数据获取
          resData = resData.mustPlayList;
          if (resData) {
            let list = this.listData;
            this.listData = list.concat(resData);
          }
          // 数据为空
          if (this.pageIndex == 1 && resData.length == 0) {
            console.log('数据为空');
            this.loading = false;
            this.finished = true;
            this.isEmptyData = true;
          }
          //   数据已加载完毕
          if ((!resData || resData.length == 0) && this.listData.length > 0) {
            console.log('数据已加载完毕');
            this.finished = true;
          }
          this.loading = false;
          this.isLoading = false;
          console.log(this.listData, 'this.listData')
        }
      }).catch((e) => {
        console.log(e, 'eeeeeeeee')
        // this.$toast('网络不稳定，请稍后重试');
        this.isPageError = true;
        this.isLoading = false;
      });
    },

    /**
     * 请求列表数据（景区名片下进入）
     */
    getListDataForPark(callback) {
      this.loading = true;
      this.finished = false;
      this.$request.get(`/appserver/v1/scenic/mustPlay?scenicId=${this.$route.query.scenicId}&pageIndex=${this.pageIndex}&pageSize=${this.pageSize}&type=${this.contentType}`).then((res) => {
        console.log(res, 'list数组');
        if (res.data.ret == 0) {
          let resData = res.data.data;
          // 顶部tag标签动态获取
          if (this.classifyArray.length < 1) {
            for (let i in resData.tags) {
              // 过滤美食和酒店
              if (resData.tags[i].type == 1 || resData.tags[i].type == 3) {
                this.classifyArray.push({
                  id: resData.tags[i].type,
                  tagName: resData.tags[i].name,
                })
              }

            }
          }
          // 列表数据获取
          if (this.contentType == 1) {
            resData = resData.activityList;
          } else if (this.contentType == 3) {
            resData = resData.scenicSpotList;
          }
          if (this.contentType == 1) { // 活动
            console.log('活动！！！！！！！！！！')
            // 景区名片的数据进行统一覆盖
            for (let i in resData) {
              resData[i].imageList = [];
              resData[i].imageList.push(resData[i].coverImg);
              resData[i].headerTagName = this.classifyArray[this.classifyActive].tagName;
            }
          } else {
            console.log('景点！！！！！！！！！！')

            // 景区名片的数据进行统一覆盖
            for (let i in resData) {
              // resData[i].imageList = [];
              // resData[i].imageList.push(resData[i].coverImg);
              resData[i].headerTagName = this.classifyArray[this.classifyActive].tagName;
            }
          }

          console.log(this.contentType, 'this.contentType')
          console.log(resData, 'resData');
          if (resData) {
            let list = this.listData;
            this.listData = list.concat(resData);
          }
          // 数据为空
          if (this.pageIndex == 1 && resData.length == 0) {
            console.log('数据为空');
            this.loading = false;
            this.finished = true;
            this.isEmptyData = true;
          }
          //   数据已加载完毕
          if ((!resData || resData.length == 0) && this.listData.length > 0) {
            console.log('数据已加载完毕');
            this.finished = true;
          }
          this.loading = false;
          this.isLoading = false;
          if (callback) {
            callback();
          }
        }
      }).catch((e) => {
        console.log(e, 'eeeeeeeee')
        // this.$toast('网络不稳定，请稍后重试');
        this.isPageError = true;
        this.isLoading = false;
      });
    },


    /**
     * 分享初始化
     */
    shareInit() {
      wx.ready(function () {
        //需在用户可能点击分享按钮前就先调用
        wx.updateAppMessageShareData({
          title: '天府绿道的游玩线路都在这里了，总有一条适合你', // 分享标题
          desc: '不要错过哦~', // 分享描述
          link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: document.getElementById('share_img').src, // 分
          success: function () {
            // 分享成功
            // console.log('已分享');
          },
        });
        wx.updateTimelineShareData({
          title: '天府绿道的游玩线路都在这里了，总有一条适合你', // 分享标题
          link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: document.getElementById('share_img').src, // 分
          success: function () {
            // 分享成功
          },
        });
      });
      wx.error(function (res) {
        // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
        // alert('error: ' + res);
      });
    },
    onLoad() {
      this.pageIndex++;
      this.getListData();
    },
    /**
     * 计算距离你多少距离
     * @params lat lng 景区 景点 经纬度
     */
    distance(lat, lng) {
      if (this.$route.query.lat && this.$route.query.lng) {
        let obj = getDistance(lat, lng, this.$route.query.lat, this.$route.query.lng);
        return { distance: obj.distance.toFixed(1), text: obj.type };
      } else {
        return { distance: '', text: '' };
      }
    }

  },
  computed: {},
};
</script>
<style lang="scss" scoped>
.mustPlay_list {
  .van-field__control {
    color: #787878;
    font-size: 14px;
    letter-spacing: 0.5px;
  }
  .head_tags {
    padding: 10px;
    overflow: hidden;
    padding-right: 0px;
    background: white;
    .tag_classif,
    .tag_park {
      display: flex;
      // display: -webkit-box;
      align-items: center;
      width: 100%;
      justify-content: space-between;
      .tag_name {
        font-size: 12px;
        margin-right: 16px;
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        // padding-bottom: 20px;
      }
      .tag_checkout {
      }
    }
    border-bottom: 5px solid rgba(216, 216, 216, 0.3);
  }
  .list_container {
    padding-left: 20px;
    // padding-top: 20px;
    /deep/.item_container {
      margin-bottom: 0px;
      margin-top: 20px;
    }
    .list {
      margin-top: 20px;
      .right_container {
        margin-left: 14px;
        width: calc(100% - 99px);
        transform: translateY(-3px);
        .right_title {
          font-size: 16px;
          color: black;
          font-weight: bold;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
        .right_time,
        .right_like {
          color: rgba(0, 0, 0, 0.5);
          font-size: 11px;
        }
        .right_time {
          color: #2ed07e;
        }
        .right_label {
          display: flex;
          align-items: center;
          margin-bottom: 0;
          div {
            font-size: 11px;
            color: #6e5adb;
            background: rgba(97, 69, 247, 0.15);
            margin-right: 5px;
            padding: 2px 4px;
          }
          .type {
            color: #2ed07e;
            background: #eaf8f0;
            border-radius: 2px;
          }
        }
        div {
          margin-bottom: 7px;
        }
      }
    }
  }
  .loading_class {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
/deep/.van-empty__image {
  width: 245px;
  height: 170px;
}
</style>
